import { consts } from "./consts.js";

const {
  componentName
} = consts;

export const setDrawnLinkComponentNotDraggable = (editor) => {
  const allDrawnComponents = editor.getWrapper().find(`[data-link-component="${componentName}"]`);
  for(const drawnComponent of allDrawnComponents) {
    drawnComponent.set({
      droppable: false,
    });
    drawnComponent.setDragMode("absolute");
  }
}